import React, { useState } from 'react';
import { Image, ImageSourcePropType, ImageStyle, StyleProp } from 'react-native';
import { getLocalTokenIcon, getTokenIconSource } from '../../tools/getCurrencyIcon';

interface Props {
  symbol: string;
  /** Catalogue icon; it carries the network badge (USDT on Tron / Ethereum). */
  iconUrl?: string | null;
  style?: StyleProp<ImageStyle>;
  resizeMode?: 'contain' | 'cover';
}

/**
 * Token icon that prefers the catalogue URL and falls back to the bundled
 * asset when the URL cannot be loaded (offline, CDN down, stale link).
 */
const TokenIcon: React.FC<Props> = ({ symbol, iconUrl, style, resizeMode = 'contain' }) => {
  const [failed, setFailed] = useState(false);
  const source = failed ? getLocalTokenIcon(symbol) : getTokenIconSource(symbol, iconUrl ?? null);
  return (
    <Image
      source={source}
      style={style}
      resizeMode={resizeMode}
      onError={() => setFailed(true)}
    />
  );
};

/**
 * Image that swaps to `fallback` when its source fails to load. Used by the
 * card components, which receive a ready source rather than a symbol.
 */
export const IconWithFallback: React.FC<{
  source?: ImageSourcePropType;
  fallback?: ImageSourcePropType;
  style?: StyleProp<ImageStyle>;
}> = ({ source, fallback, style }) => {
  const [failed, setFailed] = useState(false);
  return (
    <Image
      source={failed && fallback ? fallback : source}
      style={style}
      resizeMode="contain"
      onError={() => setFailed(true)}
    />
  );
};

export default TokenIcon;
